import Repository from './Repository'

const login_member = 'members/signin'
const login_corporate = 'corporatemember/signin'
const create_individual_member = 'individualmember/create'
const get_verification_code = 'individualmember/getverificationcode'
const corporate = 'corporatemember'

export default {
    // Login Individual Member
    loginMember(payload) {
        return Repository.post(`${login_member}`, payload)
    },

    loginCorporate(payload) {
        return Repository.post(`${login_corporate}`, payload)
    },

    createIndividualMember(payload) {
        return Repository.post(`${create_individual_member}`, payload)
    },

    getVerificationCode(payload) {
        return Repository.post(`${get_verification_code}`, payload)
    },

    getCorporate(id) {
        return Repository.get(`${corporate}/${id}`)
    }
}